import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { LaminationService } from '@app/shared/services/lamination.service';

import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-lamprod-table',
  templateUrl: './lamprod-table.component.html',
  styleUrls: ['./lamprod-table.component.css']
})
export class LamprodTableComponent implements OnInit {
  productionForm: FormGroup;
   productionId: string;
 
 
 
 
   // Mapping for Material Categories to Specifications
   materialSpecificationsMap = {
     'CLEAR BOPP ': ['CLEAR BOPP [950mm X 18Î¼m]', 'CLEAR BOPP [930mm X 18Î¼m]', 'CLEAR BOPP [720mm X 40Î¼m]'],
     'MET BOPP': ['MET BOPP 40mm * 45mm', 'MET BOPP 70mm * 90mm'],
     'ADDITIVES': ['ADDITIVES'],
     'C BOPP': ['C BOPP'],
     'CLEAR CPP': ['CLEAR CPP 5mm * 4mm', 'CLEAR CPP 7mm * 9mm'],
     'PEARLIZED BOPP': ['PEARLIZED BOPP'],
     'PET': ['PET'],
     'PET G': ['PET G'],
   };
 
   // Specifications based on selected category
   matSpecifications: string[] = [];
   paginatedOrderList: any[] = [];
 
 
 
   //table
   materialMixEntries: any[] = [];
   currentPage: number = 1;
   itemsPerPage: number = 15;
 
 
   //extended table(based on process selection)
    // Define flags for each process type
    isAddProduction: boolean = false;
    isInking: boolean = false;

    laminations: any[] = [];

    //grouping
    groupedEntries: any[] = [];

    searchOperator: string = '';
    searchTicketNo: string = '';
    paginatedEntries: any[] = [];
    filteredEntries: any[] = [];
  
    totalPages: number = 1;
   //  by date
   searchDate: string = '';  // For storing selected date
 

 constructor( private laminationService: LaminationService, private cdr: ChangeDetectorRef, private activatedRoute: ActivatedRoute,) { }

 ngOnInit(): void {
   this.loadAllLaminationProductions();
 }


 // Method to load all productions(without grouping)
 // loadAllProductions(): void {
 //   this.productionService.getAllProduction().subscribe(
 //     (productions) => {
 //       console.log('Loaded productions:', productions); // Check the structure of productions
 //       if (Array.isArray(productions)) {
 //         this.materialMixEntries = productions; // Only assign if it's an array
 //         console.log('Updated materialMixEntries:', this.materialMixEntries); // Log materialMixEntries after update
 //         this.cdr.detectChanges(); // Trigger change detection

 //       } else {
 //         console.error('Expected an array of productions, but got:', productions);
 //         this.materialMixEntries = []; // Set it to an empty array if it's not an array
 //       }
 //     },
 //     (error) => {
 //       console.error('Error loading productions:', error);
 //     }
 //   );
 // }



 //(with pagination and searches)
 loadAllLaminationProductions(): void {
   this.laminationService.getAllLaminationProduction().subscribe(
     (laminations) => {
       console.log('Loaded laminations:', laminations);
       if (Array.isArray(laminations)) {
         this.materialMixEntries = laminations.reverse();
         this.filteredEntries = this.materialMixEntries;
         this.totalPages = Math.ceil(this.filteredEntries.length / this.itemsPerPage);
         this.updatePaginatedEntries();
         this.cdr.detectChanges();
       } else {
         console.error('Expected an array of laminations, but got:', laminations);
         this.materialMixEntries = [];
         this.filteredEntries = [];
         this.paginatedEntries = [];
       }
     },
     (error) => {
       console.error('Error loading laminations:', error);
     }
   );
 }


// New method to handle matRollNo logic
getMatRollNoString(entry: any): string {
 if (entry.addProduction && entry.addProduction.length > 0) {
   return entry.addProduction.map(addProd => addProd.matRollNo || 'N/A').join(', ');
 }
 return 'N/A'; // Default if no matRollNo exists
}

// Method to handle inkColor
getInkColorString(entry: any): string {
 if (entry.inking && entry.inking.length > 0) {
   return entry.inking.map(ink => ink.inkColor || 'N/A').join(', ');
 }
 return 'N/A'; 
}

filterTable(): void {
 this.filteredEntries = this.materialMixEntries.filter((entry) => {
   const operatorMatch = entry.operator
     ?.toLowerCase()
     .includes(this.searchOperator.toLowerCase());
   const ticketNoMatch = entry.refNo
   ?.toLowerCase()
     .includes(this.searchTicketNo.toLowerCase());

const matchDate = this.searchDate ? this.isDateMatch(entry.created, this.searchDate) : true;  // Filter by created date
//     return operatorMatch && ticketNoMatch;
return operatorMatch && ticketNoMatch && matchDate;
 });

 this.totalPages = Math.ceil(this.filteredEntries.length / this.itemsPerPage);
 this.currentPage = 1;
  this.updatePaginatedEntries();
}

//with date
// filterTable(): void {
//   this.filteredEntries = this.materialMixEntries.filter(entry => {
//     const matchOperator = this.searchOperator ? entry.operator?.toLowerCase().includes(this.searchOperator.toLowerCase()) : true;
//     const matchTicketNo = this.searchTicketNo ? entry.refNo?.toLowerCase().includes(this.searchTicketNo.toLowerCase()) : true;
//     const matchDate = this.searchDate ? this.isDateMatch(entry.created, this.searchDate) : true;  // Filter by created date

//     return matchOperator && matchTicketNo && matchDate;
//   });

//   this.totalPages = Math.ceil(this.filteredEntries.length / this.itemsPerPage);
//   this.goToPage(1); // Reset to page 1 after filtering
// }

// Helper function to check if the entry's created date matches the selected search date
isDateMatch(entryDate: string, searchDate: string): boolean {
 const entryDateObj = new Date(entryDate); // Convert string to date object
 const searchDateObj = new Date(searchDate); // Convert string to date object
 return entryDateObj.toDateString() === searchDateObj.toDateString(); // Compare only the date part
}


updatePaginatedEntries(): void {
 const startIndex = (this.currentPage - 1) * this.itemsPerPage;
 const endIndex = startIndex + this.itemsPerPage;
 this.paginatedEntries = this.filteredEntries.slice(startIndex, endIndex);
}

goToPage(page: number): void {
 if (page < 1 || page > this.totalPages) return;
 this.currentPage = page;
 this.updatePaginatedEntries();
}

deleteLaminationProduction(entryId: string) {
 if (confirm('Are you sure you want to delete this Production order?')) {
   this.laminationService.deleteLaminationProduction(entryId).subscribe(() => {
     this.filteredEntries = this.filteredEntries.filter(productionorder => productionorder._id !== entryId);
     this.cdr.detectChanges();
   }, error => {
     console.error('Error while deleting this entry:', error);
   });
 }
}





// print(entry: any) {
//   const doc = new jsPDF();
 
//   const pageWidth = doc.internal.pageSize.width;
//   const topMargin = 2;
//   const sideMargin = 10;
//   doc.setFont('helvetica');
//   const adjustedTop = topMargin + 8;
//   const adjustedLeft = sideMargin + 10;
//   doc.setFont('helvetica', 'bold');
 
//   const ticketText = 'LEXIPACK GHANA LIMITED';
//   const companyName = entry.clientName || '';
//   const companyJob = `${entry.jobName || ''} (${entry.jobType || ''})`;
//   const textWidth = doc.getTextWidth(ticketText);
//   const textX = (pageWidth - textWidth) / 2;
//   doc.setFontSize(13);
//   doc.text(ticketText, textX, adjustedTop + 2);
//   doc.text(companyName, adjustedLeft, adjustedTop + 10);
//   doc.text(companyJob, adjustedLeft, adjustedTop + 16);
//   doc.line(sideMargin, adjustedTop + 18, pageWidth - sideMargin, adjustedTop + 18);
//   doc.setFontSize(11);
//   doc.setFont('helvetica', 'normal');

//   // Add other content from the entry object as needed
//   const PoNo = `Po No: ${entry.poNumber || ''}`;
//   doc.text(PoNo, adjustedLeft - 8, adjustedTop + 23);
 
//   // Other document content...
 
//   // Save the PDF
//   const pdfOutput = doc.output('bloburl');
//   window.open(pdfOutput); // Open the PDF in a new tab for preview
// }

print(entry: any) {
 const doc = new jsPDF();

 const pageWidth = doc.internal.pageSize.width;
 const topMargin = 2;
 const sideMargin = 10;
 const adjustedTop = topMargin + 8;
 const adjustedLeft = sideMargin + 10;

 doc.setFont('helvetica', 'bold');
 doc.setFontSize(13);

 // Header
 const headerText = 'LEXIPACK GHANA LIMITED';
 const textWidth = doc.getTextWidth(headerText);
 const textX = (pageWidth - textWidth) / 2;
 doc.text(headerText, textX, adjustedTop + 2);
 

 doc.setFontSize(11);
 doc.setFont('helvetica', 'normal');

 // // Basic Info
 // let currentY = adjustedTop + 10;
 // doc.text(`Client Name: ${entry.clientName || ''}`, adjustedLeft, currentY);
 // currentY += 6;
 // doc.text(`Job Name: ${entry.jobName || ''}`, adjustedLeft, currentY);
 // currentY += 6;

 // const infoLines = [
 //   `PO No: ${entry.poNumber || ''}`,
 //   `Ref No: ${entry.refNo || ''}`,
 //   // `Shift: ${entry.shift || ''}`,
 //   // `Machine: ${entry.machine || ''}`,
 //   `Operator: ${entry.operator || ''}`,
 //   // `Operating Time: ${entry.operatingTime || ''}`,
 //   `Machine Speed: ${entry.mcSpeed || ''}`,
 //   `Ink GSM: ${entry.inkGsm || ''}`,
 //   // `Order Quantity: ${entry.orderKgs || ''} kg`,
 //   // `Time From: ${entry.timeFrom || ''}`,
 //   // `Time To: ${entry.timeTo || ''}`
 // ];

 // infoLines.forEach(line => {
 //   doc.text(line, adjustedLeft, currentY);
 //   currentY += 6;
 // });



 // Sub Header - Printing Report
 const subHeaderText = 'PRINTING REPORT';
 const subTextWidth = doc.getTextWidth(subHeaderText);
 const subTextX = (pageWidth - subTextWidth) / 2;
 doc.setFontSize(11);
 doc.text(subHeaderText, subTextX, adjustedTop + 10);

 doc.setFont('helvetica', 'normal');
 doc.setFontSize(10);

 // Start position after header
 let currentY = adjustedTop + 18;

 const colSpacing = 90; // space between left and right columns
 const col1X = adjustedLeft;
 const col2X = adjustedLeft + colSpacing;

 // // Left Column: Basic Client Info
 // doc.text(`Client Name: ${entry.clientName || ''}`, col1X, currentY);
 // doc.text(`Ref No: ${entry.refNo || ''}`, col2X, currentY);
 // currentY += 6;

 // doc.text(`Job Name: ${entry.jobName || ''}`, col1X, currentY);
 // // doc.text(`PO No: ${entry.poNumber || ''}`, col2X, currentY);
 // // PO No + Ticket No in one line
 // const poText = `PO No: ${entry.poNumber || ''}`;
 // const ticketText = `Ticket No: ${entry.ticketNo || ''}`;
 // const poTextWidth = doc.getTextWidth(poText);
 // doc.text(poText, col2X, currentY);
 // doc.text(ticketText, col2X + poTextWidth + 15, currentY); // spacing of 10 units after PO No
 // currentY += 6;
 // // currentY += 6;

 // doc.text(`Operator: ${entry.operator || ''}`, col1X, currentY);
 // doc.text(`Machine Speed: ${entry.mcSpeed || ''}`, col2X, currentY);
 // currentY += 6;

 // doc.text(``, col1X, currentY); // leave left empty
 // doc.text(`Ink GSM: ${entry.inkGsm || ''}`, col2X, currentY);

 // Left Column: Basic Client Info
//   doc.text(`Job Name: ${entry.jobName || ''}`, col1X, currentY);
//   // doc.text(`Ticket No: ${entry.ticketNo || ''}`, col2X, currentY);
//   currentY += 6;

//   // doc.text(`Date: ${entry.created || ''}`, col1X, currentY);
//   // to split the date
// //   const createdDate = entry.created ? entry.created.split('T')[0] : '';
// // doc.text(`Date: ${createdDate}`, col1X, currentY);
// // beside
// const createdDate = entry.created ? entry.created.split('T')[0] : '';
// const dateText = `Date: ${createdDate}`;
// const shiftText = `Shift: ${entry.shift || ''}`;
// const dateTextWidth = doc.getTextWidth(dateText);

// doc.text(dateText, col1X, currentY);
// doc.text(shiftText, col1X + dateTextWidth + 15, currentY); // 15 units spacing after date

//   // doc.text(`PO No: ${entry.poNumber || ''}`, col2X, currentY);
//   // PO No + Ticket No in one line
//   const machineText = `Machine: ${entry.machine || ''}`;
//   const inkGsmText = `Ink GSM: ${entry.inkGsm || ''}`;
//   const machineTextWidth = doc.getTextWidth(machineText);
//   doc.text(machineText, col2X, currentY);
//   doc.text(inkGsmText, col2X + machineTextWidth + 15, currentY); // spacing of 10 units after PO No
//   currentY += 6;
//   // currentY += 6;

//   doc.text(`Operator: ${entry.operator || ''}`, col1X, currentY);
//   doc.text(`Machine Speed: ${entry.mcSpeed || ''}`, col2X, currentY);
//   currentY += 6;

//   doc.text(``, col1X, currentY); // leave left empty
//   // doc.text(`Ink GSM: ${entry.inkGsm || ''}`, col2X, currentY);
//   doc.text(`Order No: ${entry.ticketNo || ''}`, col2X, currentY);


currentY += 20;


 const formattedDate = new Date(entry.created).toISOString().split('T')[0];
 autoTable(doc, {
   startY: 25,
   body: [
     // First row: Client Name and Order Number spanning 2 columns each
     [
       { content: 'Job Name:', styles: { fontStyle: 'bold', fontSize: 10 }, colSpan: 1 },
       { content: entry.jobName, colSpan: 3 },
       { content: 'Order Number:', styles: { fontStyle: 'bold', fontSize: 10 }, colSpan: 2 },
       { content: entry.ticketNo, colSpan: 2 }
     ],
 
     // Second row: Date, Shift, Machine, Ink GSM (each taking 2 columns)
     [
       { content: 'Date:', styles: { fontStyle: 'bold', fontSize: 10 } },
       formattedDate,
       { content: 'Shift:', styles: { fontStyle: 'bold', fontSize: 10 } },
       entry.shift,
       { content: 'Machine:', styles: { fontStyle: 'bold', fontSize: 10 } },
       entry.machine,
       { content: 'Ink GSM:', styles: { fontStyle: 'bold', fontSize: 10 } },
       entry.inkGsm
     ],
 
     // Third row: Operator and Machine Speed
     [
       { content: 'Operator:', styles: { fontStyle: 'bold', fontSize: 10 } ,colSpan: 2},
       { content: entry.operator, colSpan: 2 },
       { content: 'Machine Speed:', styles: { fontStyle: 'bold', fontSize: 10 }, colSpan: 2 },
       { content: entry.mcSpeed, colSpan: 2 },
      
     ]
   ],
   theme: 'grid',
   styles: { fontSize: 10 },
   tableWidth: 180,
   columnStyles: {
     0: { cellWidth: 22.5 },
     1: { cellWidth: 22.5 },
     2: { cellWidth: 22.5 },
     3: { cellWidth: 22.5 },
     4: { cellWidth: 22.5 },
     5: { cellWidth: 22.5 },
     6: { cellWidth: 22.5 },
     7: { cellWidth: 22.5 }
   }
 });
 
 // autoTable(doc, {
 //   startY: 25,
 //   body: [
 //     // ['Client Name:', order.clientName, 'Order Status:', order.status],
 //     [{ content: 'Client Name:', styles: { fontStyle: 'bold',fontSize: 10, }  }, entry.clientName, { content: 'Order Number:',styles: { fontStyle: 'bold',fontSize: 10, } }, entry.ticketNo,
 //     ],


 //     [{ content: 'Date', styles: { fontStyle: 'bold', fontSize: 10 } }, entry.created, 
 //       { content: 'Shift:', styles: { fontStyle: 'bold', fontSize: 10 } },entry.shift,
 //       { content: 'Machine:', styles: { fontStyle: 'bold', fontSize: 10 } }, entry.machine, 
 //       { content: 'Ink GSM:', styles: { fontStyle: 'bold', fontSize: 10 } },entry.inkGsm,
 //     ],
 //     // [ { content: 'Ref No:', styles: { fontStyle: 'bold', fontSize: 10 } },{ content:entry.refNo|| 'N/A', colSpan: 4 }],
 //     // [ { content: 'PO No:', styles: { fontStyle: 'bold', fontSize: 10 } },{ content:entry.poNo|| 'N/A', colSpan: 4 }],
     

 //     // keeping one whole complete row
 //     // [ { content: 'Operator:', styles: { fontStyle: 'bold', fontSize: 10 } },{ content: entry.operator || 'N/A', colSpan: 4 }],
 //     // [ { content: 'Machine Speed:', styles: { fontStyle: 'bold', fontSize: 10 } },{ content: entry.mcSpeed|| 'N/A', colSpan: 4 }]
 //     [{ content: 'Operator:', styles: { fontStyle: 'bold',fontSize: 10, }  }, entry.operator, { content: 'Machine Speed:',styles: { fontStyle: 'bold',fontSize: 10, } }, entry.mcSpeed,
 //     ],
 //   ],
 //   theme: 'grid',
 //   styles: { fontSize: 10 },
 //   tableWidth: 180,

 //   // columnStyles: {
 //   //   // 0: { cellWidth: 40 },
 //   //   // 1: { cellWidth: 50 },
 //   //   // 2: { cellWidth: 40 },
 //   //   // 3: { cellWidth: 50 }
 //   //   0: { cellWidth: 40 },
 //   //   1: { cellWidth: 40 },  // Adjust cell width as needed
 //   //   2: { cellWidth: 40 },
 //   //   3: { cellWidth: 40 },
 //   //   4: { cellWidth: 40 },  // New column for Machine
 //   //   5: { cellWidth: 40 }   // Adjust for the extra column
 //   // }
 //   columnStyles: {
 //     0: { cellWidth: 20 },
 //     1: { cellWidth: 20 },
 //     2: { cellWidth: 20 },
 //     3: { cellWidth: 20 },
 //     4: { cellWidth: 20 },
 //     5: { cellWidth: 20 },
 //     6: { cellWidth: 20 },
 //     7: { cellWidth: 20 }
 //   }
 // });


 // Space before tables
 currentY += 12;

 // Production Table
 // if (entry.addProduction?.length) {
 //   autoTable(doc, {
 //     startY: currentY,
 //     head: [['Mat Specification', 'Mat Roll No', 'Prod Weight (kg)', 'Prod Return (kg)']],
 //     body: entry.addProduction.map((item: any) => [
 //       item.matSpecifications || 'N/A',
 //       item.matRollNo || 'N/A',
 //       item.prodWeight || 'N/A',
 //       item.prodReturn || 'N/A',
 //     ]),
 //     styles: { fontSize: 10 },
 //     headStyles: { fillColor: [41, 128, 185], textColor: 255 },
 //   });

 //   currentY = (doc as any).lastAutoTable.finalY + 10;
 // }

// Roll Information Title
doc.setFont('helvetica', 'bold');
doc.setFontSize(11);
doc.text('Roll Information', adjustedLeft, currentY);
currentY += 2;

if (entry.addProduction?.length) {
 autoTable(doc, {
   startY: currentY,
   head: [
     [
       { content: 'Input', colSpan: 4, styles: { halign: 'center',  fillColor: [220, 220, 220],  textColor: [0, 0, 0], lineWidth: 0.3,} },
       { content: 'Output', colSpan: 4, styles: { halign: 'center', fillColor: [220, 220, 220],  textColor: [0, 0, 0], lineWidth: 0.3,} }
     ],
     [
       'Material',
       'Input Roll No',
       ' Weight (kg)',
       ' Return (kg)',
     
      
       ' Output Roll No',
       ' Output (kg)',
       ' Flag',
       ' Wastage'
     ]
   ],
 // Production Table
// if (entry.addProduction?.length) {
//   autoTable(doc, {
//     startY: currentY,
//     head: [
//       [
//         'Mat Specification',
//         'Mat Roll No',
//         'Prod Weight (kg)',
//         'Prod Return (kg)',
//         'Prod Flag',
//         'Prod Output (kg)',
//         'Prod Output Roll No',
//         'Prod Waste'
//       ]
//     ],
   body: entry.addProduction.map((item: any) => [
     item.matSpecifications || 'N/A',
     item.matRollNo || 'N/A',
     item.prodWeight || 'N/A',
     item.prodReturn || 'N/A',
     
    
     item.prodOutputRollNo || 'N/A',
     item.prodOutputKg || 'N/A',
     item.prodFlag || 'N/A',
     item.prodWaste || 'N/A',
   ]),
   styles: { fontSize: 10 },
   headStyles: { fillColor: [41, 128, 185], textColor: 255 ,
     // lineWidth: 0.5,            // Thicker borders for header
     // lineColor: [200, 200, 200],
   },
 });

 currentY = (doc as any).lastAutoTable.finalY + 10;
}


// Inking Title
doc.setFont('helvetica', 'bold');
doc.setFontSize(11);
doc.text('Ink', adjustedLeft, currentY);
currentY += 2;
 // Inking Table
 if (entry.inking?.length) {
   autoTable(doc, {
     startY: currentY,
     head: [['Ink Name', 'Color', 'Type', 'Issue', 'Return']],
     body: entry.inking.map((ink: any) => [
       ink.inkName || 'N/A',
       ink.inkColor || 'N/A',
       ink.inkType || 'N/A',
       ink.issue || 'N/A',
       ink.inkReturn || 'N/A',
     ]),
     styles: { fontSize: 10 },
     headStyles: { fillColor: [39, 174, 96], textColor: 255 },
   });
 }

 // Breakdown Title
// currentY = (doc as any).lastAutoTable?.finalY + 10 || currentY + 10;
// doc.setFont('helvetica', 'bold');
// doc.setFontSize(11);
// doc.text('Breakdown', adjustedLeft, currentY);
// currentY += 2;

// if (entry.breakdown?.length) {
//   autoTable(doc, {
//     startY: currentY,
//     head: [['DownTime Type', 'Time (Minutes)', 'Remarks']],
//     body: entry.breakdown.map((item: any) => [
//       item.downTime || 'N/A',
//       item.downTimeTime || 'N/A',
//       item.downTimeRemarks || 'N/A'
//     ]),
//     styles: { fontSize: 10 },
//     headStyles: { fillColor: [231, 76, 60], textColor: 255 },
//   });
// }

// Move to next Y after ink table
currentY = (doc as any).lastAutoTable?.finalY + 10 || currentY + 10;

// Section Titles
doc.setFont('helvetica', 'bold');
doc.setFontSize(11);
doc.text('Breakdown', adjustedLeft, currentY - 2);
doc.text('Solvent ', adjustedLeft + 95, currentY - 2);

// Tables side by side
const downtimeTable = {
 head: [['DownTime Type', 'Time (Min)', 'Remarks']],
 body: entry.breakdown?.map((item: any) => [
   item.downTime || 'N/A',
   item.downTimeTime || 'N/A',
   item.downTimeRemarks || 'N/A'
 ]) || [],
};

const solventTable = {
 head: [['Solvent ', 'Type', 'Consumption']],
 body: entry.solvent?.map((item: any) => [
   item.mat || 'N/A',
   item.type || 'N/A',
   item.consumption || 'N/A'
 ]) || [],
};

// Downtime (left)
autoTable(doc, {
 startY: currentY,
 // margin: { left: adjustedLeft }, // ✅ horizontal position
 head: downtimeTable.head,
 body: downtimeTable.body,
 styles: { fontSize: 10 },
 headStyles: { fillColor: [231, 76, 60], textColor: 255 },//text color black textColor: 0
 tableWidth: 90,
 theme: 'grid'
});

// Solvent (right)
autoTable(doc, {
 startY: currentY,
 margin: { left: adjustedLeft + 90 }, // ✅ position beside the downtime table
 head: solventTable.head,
 body: solventTable.body,
 // styles: { fontSize: 10 },
 // headStyles: { fillColor: [52, 152, 219], textColor: 0 },//text color white textColor: 255
 styles: { 
   fontSize: 10, 
   cellPadding: 2,  // Adds padding inside the cells
   lineWidth: 0.1,  // Border thickness
   // lineColor: [0, 0, 0], // Border color (black)
   lineColor: [169, 169, 169],
 },
 headStyles: { 
   textColor: 30, // White text color
   fillColor: undefined, // Remove background color
   lineWidth: 0.1,  // Border thickness for header cells
   // lineColor: [0, 0, 0], // Border color for header cells
   lineColor: [169, 169, 169],
 },
 tableWidth: 90,
 theme: 'grid'
});


 // Open PDF
 const pdfOutput = doc.output('bloburl');
 window.open(pdfOutput);
}

// print(entry: any) {
//   const doc = new jsPDF();

//   const pageWidth = doc.internal.pageSize.width;
//   const topMargin = 2;
//   const sideMargin = 10;
//   const adjustedTop = topMargin + 8;
//   const adjustedLeft = sideMargin + 10;

//   doc.setFont('helvetica', 'bold');
//   doc.setFontSize(13);

//   // Header
//   const headerText = 'LEXIPACK GHANA LIMITED';
//   const textWidth = doc.getTextWidth(headerText);
//   const textX = (pageWidth - textWidth) / 2;
//   doc.text(headerText, textX, adjustedTop + 2);

//   doc.setFontSize(11);
//   doc.setFont('helvetica', 'normal');

//   // Company Info
//   doc.text(`Client Name: ${entry.clientName || ''}`, adjustedLeft, adjustedTop + 10);
//   doc.text(`Job Name: ${entry.jobName || ''}`, adjustedLeft, adjustedTop + 16);
//   doc.line(sideMargin, adjustedTop + 18, pageWidth - sideMargin, adjustedTop + 18);

//   let currentY = adjustedTop + 25;

//   // General Info
//   const lines = [
//     `PO No: ${entry.poNumber || ''}`,
//     `Ref No: ${entry.refNo || ''}`,
//     `Shift: ${entry.shift || ''}`,
//     `Machine: ${entry.machine || ''}`,
//     `Operator: ${entry.operator || ''}`,
//     `Operating Time: ${entry.operatingTime || ''}`,
//     `Machine Speed: ${entry.mcSpeed || ''}`,
//     `Ink GSM: ${entry.inkGsm || ''}`,
//     `Order Quantity: ${entry.orderKgs || ''} kg`,
//     `Time From: ${entry.timeFrom || ''}`,
//     `Time To: ${entry.timeTo || ''}`
//   ];

//   lines.forEach(line => {
//     doc.text(line, adjustedLeft, currentY);
//     currentY += 7;
//   });

//   // AddProduction Details (only first item shown)
//   if (entry.addProduction?.length) {
//     const prod = entry.addProduction[0];
//     doc.setFont('helvetica', 'bold');
//     doc.text('Material Details:', adjustedLeft, currentY + 5);
//     doc.setFont('helvetica', 'normal');
//     currentY += 12;

//     doc.text(`Material Spec: ${prod.matSpecifications || 'N/A'}`, adjustedLeft, currentY);
//     currentY += 7;
//     doc.text(`Material Roll No: ${prod.matRollNo || 'N/A'}`, adjustedLeft, currentY);
//     currentY += 7;
//     doc.text(`Produced Weight: ${prod.prodWeight || 'N/A'} kg`, adjustedLeft, currentY);
//     currentY += 7;
//     doc.text(`Returned Weight: ${prod.prodReturn || 'N/A'} kg`, adjustedLeft, currentY);
//     currentY += 10;
//   }

//   // Inking Details
//   if (entry.inking?.length) {
//     doc.setFont('helvetica', 'bold');
//     doc.text('Ink Details:', adjustedLeft, currentY);
//     doc.setFont('helvetica', 'normal');
//     currentY += 8;

//     entry.inking.forEach((ink: any, index: number) => {
//       const inkLine = `${index + 1}. ${ink.inkName || 'N/A'} | Color: ${ink.inkColor || 'N/A'} | Type: ${ink.inkType || 'N/A'} | Issue: ${ink.issue || 'N/A'} | Return: ${ink.inkReturn || 'N/A'}`;
//       doc.text(inkLine, adjustedLeft, currentY);
//       currentY += 7;
//     });
//   }

//   // Final line
//   doc.line(sideMargin, currentY + 2, pageWidth - sideMargin, currentY + 2);

//   // Open PDF
//   const pdfOutput = doc.output('bloburl');
//   window.open(pdfOutput);
// }





 




 

 //grouping with diff matrollno
 //Showed
 groupEntriesByCommonFields(): void {
   const grouped: { [key: string]: any } = {};  // Group entries by common fields
 
   this.materialMixEntries.forEach(entry => {
     // Ensure addProduction array and matRollNo exist before using them
     const matRollNo = entry.addProduction && entry.addProduction[0]?.matRollNo;
     if (!matRollNo) {
       console.warn(`matRollNo is missing for entry with refNo: ${entry.refNo}`);
     }
 
     // Create a unique key for grouping
     const key = `${entry.refNo}-${entry.clientName}-${entry.jobName}-${entry.poNumber}-${entry.orderKgs}`;
 
     // Initialize group if it doesn't exist
     if (!grouped[key]) {
       grouped[key] = {
         matRollNos: new Set([matRollNo]),  // Track matRollNo to avoid duplicates
         availTime: entry.addProduction[0]?.availTime || 'N/A',
         entries: [entry],  // Store entries that belong to this group
       };
     } else {
       // Check if matRollNo is different, and add the entry to the group's entries
       if (matRollNo && !grouped[key].matRollNos.has(matRollNo)) {
         grouped[key].matRollNos.add(matRollNo);
         grouped[key].entries.push(entry);  // Add new entry for different matRollNo


         // (detail detail)
         // Log the details of addProduction array when matRollNo is different
       // console.log(`matRollNo is different in group: ${grouped[key].entries[0].refNo}`);
       // console.log('Details of addProduction for the current entry:', entry.addProduction);
       }
     }
   });
 
   // Log different matRollNo values for each group
   Object.entries(grouped).forEach(([groupKey, groupValue]) => {
     console.log(`Group: ${groupKey}`);  // Log group key (refNo-clientName-jobName-poNumber-orderKgs)
 
     // If there are multiple unique matRollNo values
     if (groupValue.matRollNos.size > 1) {
       console.log('Different matRollNo values in this group:', Array.from(groupValue.matRollNos));
     } else {
       console.log('Same matRollNo across all entries in this group:', Array.from(groupValue.matRollNos));
     }
   });
 
   // Flatten the entries from all groups into a single array
   this.groupedEntries = Object.values(grouped).reduce<any[]>((acc, group) => {
     return acc.concat(group.entries);  // Concatenate entries, including those with different matRollNo
   }, []);
 }



 
 
 
 
 



}
